import { useField } from "formik";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Button from "_shared/components/Button/Button";
import "../register/Register.scss";
import plans from "../../../_shared/constants/plans";
import { FormValues } from "../_shared/models/FormValues";
import { ProductDetails } from "../_shared/models/ProductDetails";
import styles from "./SelectPlan.module.scss";
import { analytics } from "_shared/utils/analytics";

interface Props {
  productDetails: Record<string, ProductDetails>;
  onBack: () => void;
  onNext: () => void;
}

const SelectPlan: React.FC<Props> = ({ productDetails, onBack, onNext }) => {
  const [{ value: plan, onChange }] = useField<FormValues["plan"]>("plan");
  // TODO: frequency is currently locked at daily
  const [{ value: frequency }] = useField<FormValues["frequency"]>("frequency");
  // TODO: only monthly payment plans are currently available
  const [planPayments, setPlanPayments] = useState("monthly");

  const location = useLocation<any>();
  useEffect(() => {
    if (process.env.NODE_ENV === "test") return;
    // Twitter tracking
    (window as any).twq("event", "tw-o90ig-oe3te", {
      value: null, // use this to pass the value of the conversion (e.g. 5.00)
      currency: "USD", // use this to pass the currency of the conversion with an ISO 4217 code (e.g. ‘USD’)
      conversion_id: location.state?.sub, // use this to pass a unique ID for the conversion event for deduplication (e.g. order id '1a2b3c')
    });
  }, [location.state?.sub]);

  return (
    <div className={styles.container}>
      <div className="border-padding">
        <h2
          className="welcome-text"
          style={{ fontWeight: 800, marginBottom: 5, marginTop: 20 }}
        >
          Select Plan
        </h2>
        <h2 className="welcome-text" style={{ fontSize: 12 }}>
          Choose a Longbow plan below
        </h2>
        {/* plan buttons that set form state */}
        <div className={styles.planButtons} data-testid="plan-buttons">
          {plans.map((currentPlan) => (
            <button
              key={currentPlan.key}
              className={plan === currentPlan.key ? styles.selected : ""}
              onClick={() => {
                analytics.track("Signup Plan Selected", {
                  plan: currentPlan.name,
                });
                onChange("plan")(currentPlan.key);
              }}
              data-testid={`planbutton-${currentPlan.key}`}
            >
              {currentPlan.name}
            </button>
          ))}
        </div>
        <div className={styles.paymentButtons}>
          {["Monthly"].map((payment) => (
            <button
              key={payment}
              data-testid={`paymentbutton-${payment}`}
              className={
                planPayments === payment.toLowerCase() ? styles.selected : ""
              }
              onClick={() => {
                setPlanPayments(payment.toLowerCase());
              }}
            >{`${payment}: ${
              productDetails[plan]
                ? "$" +
                  productDetails[plan][
                    `${payment.toLowerCase()}_${frequency}_price` as keyof ProductDetails
                  ]
                : "----"
            }`}</button>
          ))}
        </div>
        {productDetails[plan] ? (
          <div role="definition" className={styles.planDetails}>
            <p>
              <mark>{productDetails[plan].name.split(" ")[0]}</mark> includes{" "}
              <mark>{productDetails[plan].total_tickers} tickers</mark> updated{" "}
              <mark>{frequency}</mark>.
            </p>
            You will be billed <mark>{planPayments}</mark> for this plan.
          </div>
        ) : null}
        <br />
        <div className={styles.totalAmount}>
          {productDetails[plan]
            ? `Your total: $${
                productDetails[plan][
                  `${planPayments}_${frequency}_price` as keyof ProductDetails
                ]
              }`
            : "----"}
        </div>

        <Button
          className="next-button"
          onClick={onNext}
          fullWidth
          data-testid="button-next"
        >
          Next
        </Button>
        <Button onClick={onBack} variant="secondary" fullWidth>
          Back
        </Button>
      </div>
    </div>
  );
};

export default SelectPlan;
